
import { Debt } from '../../api/getDebts';
import SummaryRow from '../../components/Summary/SummaryRow';
import { formatNumberByThousands } from '../../helpers/formatNumberByThousands';
import { getAccountTypeTranslationKey } from '../../helpers/getAccountTypeTranslationKey';
import useTranslation from '../../hooks/useTranslation';
import { Consolidation } from '../../types/ConsolidationTypes';

const getConsolidationText = (consolidation: Debt | Consolidation, translate: (key: string) => string) => {
    let result = `${translate(getAccountTypeTranslationKey(consolidation.accountType ?? 'UNKNOWN'))}`;

    if (consolidation.creditorName) {
        result += `, ${consolidation.creditorName}`;
    }

    if (consolidation.currentBalance) {
        if (
            'consolidationType' in consolidation &&
            consolidation.consolidationType === 'PARTIAL' &&
            consolidation.consolidationAmount
        ) {
            result += `, ${formatNumberByThousands(consolidation.consolidationAmount.amount)} ${translate(
                'field.currency.label',
            )} ${translate('field.partial-amount.of')} ${formatNumberByThousands(
                consolidation.currentBalance.amount,
            )} ${translate('field.currency.label')}`;
        } else {
            result += `, ${formatNumberByThousands(consolidation.currentBalance.amount)} ${translate(
                'field.currency.label',
            )}`;
        }
    }
    return result;
};

type ConsolidationsSummaryRowProps = {
    consolidations: Debt[] | Consolidation[];
};

const ConsolidationsSummaryRow = ({ consolidations }: ConsolidationsSummaryRowProps) => {
    const translate = useTranslation();

    return (
        <>
            {consolidations.map((consolidation) => (
                <SummaryRow
                    key={consolidation.internalId}
                    value={getConsolidationText(consolidation, translate)}
                    label={translate('page.submit.consolidation.label')}
                />
            ))}
        </>
    );
};

export default ConsolidationsSummaryRow;
